import { Provider } from 'react-redux'

import { configureStore } from 'checkout/redux/store'
import { Coupon } from 'checkout/containers/Coupon'

const store = configureStore()

const PaymentWithProvider = ({ couponCode, hasService }) => {
  localStorage.setItem('@checkout:coupon', couponCode)

  return (
    <Provider store={store}>
      <Coupon hasService={hasService} />
    </Provider>
  )
}

export default PaymentWithProvider
